import React, { ChangeEvent, useContext } from 'react'
import { IdentifyModalValue }          from './StartModal'
import LazyImg                from 'javascripts/common/LazyImg'
import styles                 from './ModalThirdView.module.scss'
import ChangeModal from './changeModal'

import Icon from '../../../../../assets/images/identify/icon_third.svg'
import ModalButton from 'spa/member/components/ModalButton'

const ModalThirdView: React.FC<ChangeModal> = (props) => {
  const context = useContext(IdentifyModalValue)
  const options = [
    { value: 'false', text: '日本' },
    { value: 'true', text: '日本以外' },
  ]

  const setItem = (event: ChangeEvent<HTMLSelectElement>) => {
    context.setSelectNational(event.target.value.toLowerCase())
    if (event.target.value.toLowerCase() === 'true') {
      context.setSelectOverseas(true)
    } else {
      context.setSelectOverseas(false)
    }
  }

  const selectNationality = () => {
    return(
        <>
          <select value={context.selectNational} onChange={event => setItem(event)} className={styles.selectBox}>
            {options.map(option => (
                <option key={option.value} value={option.value}>
                  {option.text}
                </option>))}
          </select>
        </>
    )
  }

  const nextModal = () => {
    props.changeModal('fourthModal')
  }

  return (
    <>
      <div>
        <div className={styles.overlay}>
          <div className={`${styles.modalContainer} js-modal-container`}>
            <div className={styles.identificationIcon}><LazyImg src={Icon} /></div>
            <div className={styles.sectionTitle}><p><span>国籍</span>の選択</p></div>
            <div className={styles.sectionText}>
              <p>あなたの国籍を選択してください。</p>
            </div>
            <div className={styles.sectionSelect}>{selectNationality()}</div>
            <div className={styles.sectionBtn}>
              <ModalButton buttonType='BACK' onClick={() => props.changeModal('secondModal')}>1つ前に戻る</ModalButton>
              <ModalButton buttonType='NEXT' onClick={() => nextModal()}>次へ</ModalButton>
            </div>
            <div className={styles.sectionBtnClose}><button onClick={() => props.changeModal('')} className={styles.btnItemClose}>キャンセル</button></div>
          </div>
        </div>
      </div>
    </>
  )
}
export { ModalThirdView }
